module.exports = __webpack_public_path__ + "static/Giant_Stone-a5b5ad5123494cfab737f4d7a39c548f.jpg";